// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"ff106174","275":"1a69b9f3","388":"0fe7ed78","641":"922b87d7","906":"977740dc","920":"c61633f1"}[chunkId] + ".chunk.css";
};